import { MediaUploadInput } from "../../components/MediaUploadInput";
import { RegisterCard } from "../../components/RegisterCard";
import { CircleLoader } from "../../components/CircleLoader";
import { Trophy, BookOpen, Joystick, Activity, Plus } from "lucide-react";

export const CAsport = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  const activities = [
    { id: "learning", label: "Learning", icon: <BookOpen size={16} /> },
    { id: "playing", label: "Playing", icon: <Joystick size={16} /> },
  ];

  return (
    <div className="w-full max-w-4xl mx-auto p-4 animate-in fade-in duration-500">
      <RegisterCard
        title="School Activities"
        details="Log daily engagement and performance."
      />

      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[2.5rem] border border-slate-100 shadow-xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-8 space-y-8 order-2 lg:order-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Activity Type */}
            <div className="space-y-3">
              <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
                Type
              </label>
              <div className="flex gap-2 p-1 bg-slate-100 rounded-2xl">
                {activities.map((act) => (
                  <button
                    key={act.id}
                    type="button"
                    onClick={() => onFormChange("activity_type", act.id)}
                    className={`flex-1 py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2 transition-all
                      ${formData["activity_type"] === act.id ? "bg-white text-blue-600 shadow-sm" : "text-slate-400"}`}
                  >
                    {act.icon} {act.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Morale Level */}
            <div className="space-y-3">
              <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1 flex items-center gap-2">
                <Activity size={14} className="text-rose-500" /> Engagement
              </label>
              <div className="flex bg-slate-100 p-1 rounded-2xl">
                {["Not Active", "Normal", "Very Active"].map((lvl) => (
                  <button
                    key={lvl}
                    type="button"
                    onClick={() => onFormChange("morale", lvl.toLowerCase())}
                    className={`flex-1 py-2.5 rounded-xl font-bold text-[10px] uppercase tracking-tighter transition-all
                      ${formData["morale"] === lvl.toLowerCase() ? "bg-white text-slate-900 shadow-sm" : "text-slate-400"}`}
                  >
                    {lvl}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              Notes
            </label>
            <textarea
              value={formData["description"]}
              onChange={(e) => onFormChange("description", e.target.value)}
              className="w-full p-5 bg-slate-50 border-2 border-slate-100 rounded-[1.5rem] min-h-[100px] outline-none focus:bg-white focus:border-blue-500 transition-all"
              placeholder="What did the child achieve today?"
            />
          </div>

          <div className="space-y-3">
            <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              Evidence (Photo/Video)
            </label>
            <div className="p-4 bg-slate-50 border-2 border-dashed border-slate-200 rounded-2xl">
              <MediaUploadInput
                singleOption={false}
                onChangeFn={(e: any, type: any) =>
                  onFormChange(
                    type === "video" ? "video" : "image",
                    e && type === "video"
                      ? e.target.files[0]
                      : e && type === "image"
                        ? e.target.files
                        : "",
                  )
                }
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-slate-900 text-white rounded-2xl font-black uppercase tracking-widest hover:bg-black transition-all flex items-center justify-center gap-3"
          >
            {loading ? (
              <CircleLoader />
            ) : (
              <>
                <Plus size={20} /> Add Activity
              </>
            )}
          </button>
        </div>

        <div className="lg:w-64 bg-slate-50 flex items-center justify-center p-8 order-1 lg:order-2 border-l border-slate-100">
          <img
            src="/img/trophy.svg"
            className="w-40 h-40 animate-float"
            alt="trophy"
          />
        </div>
      </form>
    </div>
  );
};
